import ProjectList from "../classes/project.js";
import Pagination from "../classes/pagination.js";
import {
  post_data,
  debounce,
  set_layout_icon,
  search,
  change_layout_style,
} from "../helpers/functions.js";
import { toggleSearchInput } from "../helpers/toggle_search.js";
import Modal from "../classes/modal.js";
import { logout } from "../helpers/logout.js";


export default async function projects_page() {

  if (window.location.href.indexOf("/projects") === -1) return;

  const form = new FormData();
  form.append(
    "data",
    JSON.stringify({ function: "get_projects", getCount: true })
  );
  const response = await post_data("./includes/ajax.inc.php", form);

  let projects = {};

  if (response){
    const count = response.pop();
    projects = new ProjectList(response);
    projects.display_data();

    const local_storage_key = "projects_display_style";
    set_layout_icon(local_storage_key);
    change_layout_style(projects, local_storage_key);
    const search_input = document.querySelector(".navigation-search__input");
    const function_name = "get_projects";
    search_input &&
      search_input.addEventListener(
        "keyup",
        debounce((event) => search(event, function_name, projects, pagination))
      );

    const pagination = new Pagination(count);
    pagination.display_pagination();
    pagination.container &&
      pagination.container.addEventListener("click", (event) => {
        event.stopPropagation();
        if (!event.target.classList.contains("pagination-item")) return;
        pagination.change_page(event);
        form.append(
          "data",
          JSON.stringify({
            function: "get_projects",
            page: pagination.current_page,
            collection: collection.value,
            // search: search_input.value,
          })
        );
        post_data("./includes/ajax.inc.php", form).then((response) => {
          projects.set_data(response);
          projects.display_data();
        });
      });

  }
  
  document.addEventListener("change", async (event) => {
    if (event.target.id !== "collection") return;
    event.stopPropagation();
    form.append(
      "data",
      JSON.stringify({
        function: "get_projects",
        page: pagination.current_page,
        collection: collection.value,
        search: search_input.value,
        getCount: true,
      })
    );
    const response = await post_data("./includes/ajax.inc.php", form);
    projects.set_data(response);
    projects.display_data();
    const count = response ? response.pop() : 0;
    if (pagination === false) return;
    pagination.total_pages = Math.ceil(count / pagination.items_per_page);
    pagination.current_page = 1;
    pagination.display_pagination();
  });

  const modal = new Modal();
  document.addEventListener("click", (e) => {
    e.stopPropagation();
    toggleSearchInput(e);
    modal.toggleModal(e);
    projects.toggleDropdown(e);
    projects.createNewProject(e);
    projects.renameProject(e);
    projects.duplicateProjectFunction(e);
    projects.duplicateProjectAllFunction(e);
    projects.createTemplateFunction(e);
    if (e.target.classList.contains("logout")) logout(e);
    else if (
      e.target.classList.contains("layout-list-item__data") ||
      e.target.classList.contains("layout-list-item__data-text")
    ) {
      e.preventDefault();
      const link = e.target.classList.contains("layout-list-item__data")
        ? e.target.getAttribute("data-link")
        : e.target.parentElement.getAttribute("data-link");
      window.location.href = link;
    }
  });


  const companySelect = document.getElementById('company_selection');

    // Add an event listener to detect changes
    companySelect.addEventListener('change', async function() {
      // Get the selected option's value (company_id)
      const selectedCompanyId = this.value;
    
      // Set the selected company ID in a cookie
      document.cookie = `selected_company=${selectedCompanyId}; path=/; max-age=2592000`; // 30 days expiration
    
      // Get the 'user_access' cookie and decode it
      const userAccessJson = getCookie('user_access');
      const userAccessArray = JSON.parse(decodeURIComponent(userAccessJson));
    
      // Find the selected company in the user access array
      const selectedCompany = userAccessArray.find(access => access.company_id == selectedCompanyId);
    
      // Check if the selected company exists and has a logo
      if (selectedCompany && selectedCompany.company_logo) {
        const sidebarLogoImg = document.querySelector('.sidebar__logo img');
        if (sidebarLogoImg) {
          sidebarLogoImg.src = selectedCompany.company_logo; // Update the logo image path
        }
      }
    
      // Perform AJAX call only if we're on the /projects page
      if (window.location.href.indexOf("/projects") === -1) return;
    
      // Prepare the form data for the AJAX request
      const form = new FormData();
      form.append(
        "data",
        JSON.stringify({
          function: "get_projects",
          getCount: true
        })
      );
    
      // Perform the AJAX request to get projects based on the selected company
      const response = await post_data("./includes/ajax.inc.php", form);
    
      // Handle the response
      if (!response) return;
    
      // Extract and display the project list
      const count = response.pop(); // If there's a count value returned at the end
      const projects = new ProjectList(response);
      projects.display_data();
    });
    
  // Helper function to get the cookie by name
  function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) return parts.pop().split(';').shift();
    return null;
  }

  
}
